import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { restaurantService } from "../services";
import arrowLeft from "../assets/images/navbar/arrow-left.png";

// Aligned with mobile App/Screens/Order/PayBillDining.tsx (presentational pay-bill flow)
const PayBillDining = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [restaurant, setRestaurant] = useState<any>(null);
  const [billAmount, setBillAmount] = useState("200");
  const [showOffers, setShowOffers] = useState(false);
  const [appliedOffer, setAppliedOffer] = useState<string | null>(null);

  const offers = [
    {
      id: "1",
      code: "SAVE20",
      title: "Flat 20% Off",
      description: "Pay bill via Duddus to get 20% off",
    },
    {
      id: "2",
      code: "FLAT50",
      title: "Flat ₹50 Off",
      description: "Valid on bills above ₹300",
    },
  ];

  useEffect(() => {
    const fetchRestaurant = async () => {
      if (!id) return;
      try {
        const res: any = await restaurantService.getSingleRestaurant(id);
        setRestaurant(res.data || null);
      } catch (error) {
        console.error(error);
      }
    };
    fetchRestaurant();
  }, [id]);

  const amount = parseFloat(billAmount) || 0;
  const discount =
    appliedOffer === "SAVE20"
      ? amount * 0.2
      : appliedOffer === "FLAT50"
      ? 50
      : 0;
  const total = Math.max(amount - discount + (appliedOffer ? 10 : 0), 0);

  const handlePay = () => {
    toast.success(`Bill payment of ₹${total.toFixed(2)} initiated`);
    navigate(-1);
  };

  return (
    <div className="bg-white dark:bg-gray-900 min-h-screen mt-[7.5rem] md:mt-[72px] transition-colors">
      <div className="max-w-lg mx-auto p-4 md:p-6">
        <div className="flex items-center gap-3 mb-6">
          <button onClick={() => navigate(-1)} className="w-10 h-10 flex items-center justify-center">
            <img src={arrowLeft} alt="back" className="w-6 h-6 dark:invert" />
          </button>
          <h1 className="text-[#050505] dark:text-white font-urbanist text-[22px] font-semibold">
            Pay Bill
          </h1>
        </div>

        <div className="rounded-[16px] border dark:border-gray-700 p-4 mb-6">
          <h2 className="text-[#050505] dark:text-white font-semibold">
            {restaurant?.businessName || "Restaurant"}
          </h2>
          <p className="text-sm text-[#6A6A6A] dark:text-gray-400 mt-1">
            {restaurant?.location?.address || ""}
            {restaurant?.location?.city ? `, ${restaurant.location.city}` : ""}
          </p>
        </div>

        {!showOffers ? (
          <>
            <p className="text-[#050505] dark:text-white font-semibold mb-3">
              Enter Bill Amount
            </p>
            <div className="flex items-center gap-2 px-4 py-3 rounded-[12px] bg-[#F5F5F5] dark:bg-gray-800 mb-6">
              <span className="text-xl dark:text-white">₹</span>
              <input
                type="number"
                value={billAmount}
                onChange={(e) => setBillAmount(e.target.value)}
                className="flex-1 bg-transparent outline-none text-xl font-semibold dark:text-white"
              />
            </div>
            <button
              onClick={() => setShowOffers(true)}
              className="w-full py-4 rounded-[150px] bg-[#7402A7] text-white font-semibold"
            >
              Proceed
            </button>
          </>
        ) : (
          <>
            <p className="text-sm text-gray-400 line-through mb-1">
              ₹{(parseFloat(billAmount) || 0).toFixed(2)}
            </p>
            <p className="text-3xl font-semibold dark:text-white mb-6">
              ₹{total.toFixed(2)}
            </p>

            <p className="font-semibold dark:text-white mb-3">Available Offers</p>
            <div className="space-y-3 mb-6">
              {offers.map((offer) => (
                <div
                  key={offer.id}
                  className="flex justify-between items-center border dark:border-gray-700 rounded-[12px] p-3"
                >
                  <div>
                    <p className="font-semibold dark:text-white">{offer.title}</p>
                    <p className="text-xs text-gray-500">{offer.description}</p>
                  </div>
                  <button
                    onClick={() =>
                      setAppliedOffer(
                        appliedOffer === offer.code ? null : offer.code
                      )
                    }
                    className="text-[#7402A7] font-semibold text-sm"
                  >
                    {appliedOffer === offer.code ? "REMOVE" : "APPLY"}
                  </button>
                </div>
              ))}
            </div>

            <button
              onClick={handlePay}
              className="w-full py-4 rounded-[150px] bg-[#7402A7] text-white font-semibold"
            >
              Pay ₹{total.toFixed(2)}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PayBillDining;
